var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ElContainer",
    { staticClass: "_fc-designer", style: "height:" + _vm.height_ },
    [
      _c(
        "ElMain",
        [
          _c(
            "ElContainer",
            { staticStyle: { height: "100%" } },
            [
              _c(
                "el-aside",
                { staticClass: "_fc-l", attrs: { width: "280px" } },
                [
                  _vm._l(_vm.menuList, function (item, index) {
                    return [
                      _c(
                        "div",
                        { key: index, staticClass: "_fc-l-group" },
                        [
                          _c(
                            "el-tabs",
                            {
                              model: {
                                value: _vm.activeName,
                                callback: function ($$v) {
                                  _vm.activeName = $$v
                                },
                                expression: "activeName",
                              },
                            },
                            [
                              _c(
                                "el-tab-pane",
                                {
                                  staticClass: "mb20 mt20",
                                  attrs: { label: "控件", name: "first" },
                                },
                                [
                                  _c(
                                    "draggable",
                                    {
                                      staticClass: "pl10",
                                      attrs: {
                                        group: {
                                          name: "default",
                                          pull: "clone",
                                          put: false,
                                        },
                                        sort: false,
                                        list: item.list,
                                      },
                                    },
                                    _vm._l(item.list, function (data, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "_fc-l-item mb20",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "acea-row row-middle row",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "_fc-l-name" },
                                                [_vm._v(_vm._s(data.label))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "_fc-l-icon mr5",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fc-icon",
                                                    class:
                                                      data.icon || "icon-input",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-tab-pane",
                                {
                                  staticClass: "mt10",
                                  attrs: { label: "控件组", name: "second" },
                                },
                                [
                                  _c("div", { staticClass: "pl10 _fc-title" }, [
                                    _vm._v("人事管理"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "draggable",
                                    {
                                      staticClass: "pl10",
                                      attrs: {
                                        group: {
                                          name: "default",
                                          pull: "clone",
                                          put: false,
                                        },
                                        sort: false,
                                        list: item.group,
                                      },
                                    },
                                    _vm._l(item.group, function (data, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "_fc-l-item mb20",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "acea-row row-middle row",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "_fc-l-name" },
                                                [_vm._v(_vm._s(data.label))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "_fc-l-icon mr5",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fc-icon",
                                                    class:
                                                      data.icon || "icon-input",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "pl10 _fc-title" }, [
                                    _vm._v("客户管理"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "draggable",
                                    {
                                      staticClass: "pl10",
                                      attrs: {
                                        group: {
                                          name: "default",
                                          pull: "clone",
                                          put: false,
                                        },
                                        sort: false,
                                        list: item.contract,
                                      },
                                    },
                                    _vm._l(
                                      item.contract,
                                      function (data, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "_fc-l-item mb20",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "acea-row row-middle row",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "_fc-l-name" },
                                                  [_vm._v(_vm._s(data.label))]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "_fc-l-icon mr5",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fc-icon",
                                                      class:
                                                        data.icon ||
                                                        "icon-input",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "ElContainer",
                { staticClass: "_fc-m" },
                [
                  _c("ElMain", { staticStyle: { padding: "0" } }, [
                    _c(
                      "div",
                      { staticClass: "_fc-m-drag drag-center" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "_fc-m-tools",
                            attrs: { height: "45" },
                          },
                          [
                            _vm._t("handle"),
                            _vm._v(" "),
                            _c("div", { staticClass: "edit" }, [
                              _vm._v("编辑字段"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "handle-r" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "mr20 views",
                                  on: { click: _vm.previewFc },
                                },
                                [
                                  _c("span", {
                                    staticClass: "iconfont icondakai",
                                  }),
                                  _vm._v(" 预览"),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "views views-c",
                                  on: { click: _vm.clearDragRule },
                                },
                                [
                                  _c("span", {
                                    staticClass: "iconfont iconshanchu1",
                                  }),
                                  _vm._v(" 清空\n                "),
                                ]
                              ),
                            ]),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("FormCreate", {
                          attrs: {
                            rule: _vm.dragForm.rule,
                            option: _vm.form.value,
                          },
                          model: {
                            value: _vm.dragForm.api,
                            callback: function ($$v) {
                              _vm.$set(_vm.dragForm, "api", $$v)
                            },
                            expression: "dragForm.api",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ElAside",
                { staticClass: "_fc-r", attrs: { width: "320px" } },
                [
                  _c(
                    "ElContainer",
                    { staticStyle: { height: "100%" } },
                    [
                      _c(
                        "ElMain",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.activeTab === "props",
                              expression: "activeTab === 'props'",
                            },
                          ],
                          key: _vm.activeRule ? _vm.activeRule._id : "",
                          staticClass: "aside-right",
                          staticStyle: { padding: "0 20px" },
                        },
                        [
                          _c(
                            "div",
                            [
                              _vm.showBaseRule
                                ? _c("ElDivider", [_vm._v("表单内容说明")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.basicForm.rule
                                ? _c("FormCreate", {
                                    attrs: {
                                      rule: _vm.basicForm.rule,
                                      option: _vm.basicForm.options,
                                    },
                                    on: {
                                      change: _vm.basicChange,
                                      removeField: _vm.basicRemoveField,
                                    },
                                  })
                                : _c("FormCreate", {
                                    attrs: {
                                      rule: _vm.baseForm.rule,
                                      option: _vm.baseForm.options,
                                    },
                                    on: { change: _vm.baseChange },
                                    model: {
                                      value: _vm.baseForm.api,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.baseForm, "api", $$v)
                                      },
                                      expression: "baseForm.api",
                                    },
                                  }),
                              _vm._v(" "),
                              _vm.propsForm.rule.length > 0
                                ? _c("ElDivider", [_vm._v("表单内容配置")])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("FormCreate", {
                                attrs: {
                                  rule: _vm.propsForm.rule,
                                  option: _vm.propsForm.options,
                                },
                                on: {
                                  change: _vm.propChange,
                                  removeField: _vm.propRemoveField,
                                },
                                model: {
                                  value: _vm.propsForm.api,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.propsForm, "api", $$v)
                                  },
                                  expression: "propsForm.api",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ElDialog",
                {
                  staticClass: "dialog",
                  attrs: {
                    visible: _vm.preview.state,
                    width: "800px",
                    "append-to-body": "",
                  },
                  on: {
                    "update:visible": function ($event) {
                      return _vm.$set(_vm.preview, "state", $event)
                    },
                  },
                },
                [
                  _vm.preview.state
                    ? _c("viewForm", {
                        attrs: {
                          rule: _vm.preview.rule,
                          option: _vm.preview.option,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }